module.exports = __webpack_public_path__ + "img/LamdeiniLearning-222.67c4118e.jpg";